import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tablePerfilOpcionesView.
 * @extends JetView
 */
export default class tablePerfilOpcionesView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format the result
                    node.firstChild.innerHTML = resultFormat; // Update node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summColumn filter
        );

        return {
            view: 'treetable', // Define the view type
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            scheme: {
                $group: {
                    by: 'Titulo', // Grouping by 'Titulo' field
                },
            },
            bready: function () {
                this.openAll(); // Expand all rows on bread crumb click
            },
            footer: true, // Enable footer
            columns: [
                // Define columns for the tree table
                {
                    id: 'Menu',
                    header: _('Menu'), // Localized header
                    width: 300,
                    template: function (obj, common) {
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Render group header
                        return obj.Menu; // Render menu item
                    },
                },
                { id: 'Submenu', header: _('Submenu'), width: 150 }, // Submenu column
                { id: 'add', header: _('Adicionar'), width: 150 }, // Add column
                { id: 'Edit', header: _('Editar'), width: 150 }, // Edit column
                { id: 'Remove', header: _('Eliminar'), width: 150 }, // Remove column
            ],
            autowidth: false, // Disable automatic width adjustment
            data: [
                // Initial data for the tree table
                {
                    Menu: 'Gestión',
                    Submenu: '	Activar Registros',
                    add: 'Si',
                    Edit: 'Si',
                    Remove: 'Si',
                    Titulo: 'Administrador General',
                },
                {
                    Menu: 'Caja',
                    Submenu: 'Flujo Caja',
                    add: 'Si',
                    Edit: 'Si',
                    Remove: 'Si',
                    Titulo: 'Cajero',
                },
                {
                    Menu: 'Reportes',
                    Submenu: 'Consulta Online Detalle',
                    add: 'Si',
                    Edit: 'Si',
                    Remove: 'Si',
                    Titulo: 'Administrador Secundario',
                },
            ],
            math: true, // Enable mathematical operations
            datafetch: 10, // Number of records to fetch
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        // Event listener for filtering options
        this.on(this.app, 'perfilOpciones:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            // Build query string based on filter data
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1, // Load grid data with query string
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load grid data filtered by PlayerId
            );
        });
    }
}

// FILE DOCUMENTED
